enum TIME_UNIT {
  HOUR = "hour",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
}

export const getReleaseDateTitle = (startDate: number) => {
  if (startDate && new Date(startDate) > new Date())
    return useDateFormat(startDate, "DD.MM.YYYY").value;
};

export const getAccessLabels = (type: string): IModelAccessLabels => {
  const { t } = useI18n();

  const title = type === "svod"
    ? t("pages.account_subscription.label_full_access")
    : t("pages.account_subscription.label_limited_access");

  const description = type === "svod"
    ? t("pages.account_subscription.label_full_access_description")
    : t("pages.account_subscription.label_limited_access_description");

  return { title, description };
};

export const getDurationUnitsTitle = (total: number, unit: string) => {
  const { t } = useI18n();
  const plural = total > 1 ? 2 : 1;

  switch (unit) {
    case TIME_UNIT.HOUR:
      return t("labels.hours", plural);
    case TIME_UNIT.DAY:
      return t("labels.days", plural);
    case TIME_UNIT.WEEK:
      return t("labels.weeks", plural);
    case TIME_UNIT.MONTH:
      return t("labels.months", plural);
    case TIME_UNIT.YEAR:
      return t("labels.years", plural);
    default:
      return "";
  }
};

export const calculateDate = (count: number, unit: string) => {
  const expiryDate = new Date();

  switch (unit) {
    case TIME_UNIT.HOUR:
      return expiryDate.setHours(expiryDate.getHours() + count);
    case TIME_UNIT.DAY:
      return expiryDate.setDate(expiryDate.getDate() + count);
    case TIME_UNIT.WEEK:
      return expiryDate.setDate(expiryDate.getDate() + (count * 7));
    case TIME_UNIT.MONTH:
      return expiryDate.setMonth(expiryDate.getMonth() + count);
    case TIME_UNIT.YEAR:
      return expiryDate.setFullYear(expiryDate.getFullYear() + count);
    default:
      return "";
  }
};

export const getDurationLabel = (subscription: IModelCommerce): string => {
  const { t } = useI18n();
  const { duration, durationUnits, endDate, autoRenew } = subscription;
  const type = autoRenew ? "durationRenew" : "duration";

  if (duration && durationUnits)
    return t(`labels.${type}`, { duration, units: getDurationUnitsTitle(duration, durationUnits) });
  else if (endDate)
    return t(`labels.${type}`, { duration: useDateFormat(endDate, "DD.MM.YYYY").value }, 0);

  return "N/A";
};

export const getExpirationDate = (subscription: IModelCommerce) => {
  const { t } = useI18n();
  const { duration, durationUnits, endDate, autoRenew } = subscription;
  const type = autoRenew ? "renew_subscription_expires" : "subscription_expires";

  if (duration && durationUnits)
    return t(`pages.account_subscription.${type}`, { date: useDateFormat(calculateDate(duration, durationUnits), "DD.MM.YYYY").value });
  else if (endDate)
    return t(`pages.account_subscription.${type}`, { date: useDateFormat(endDate, "DD.MM.YYYY").value });

  return "N/A";
};

export const getPriceLabel = (price: number, currency: string) => {
  const runtimeConfig = useRuntimeConfig().public;
  const currencyFormat = runtimeConfig.APP_CUSTOMER.currency_format;
  if (currencyFormat === "ltr")
    return `${currency} ${price}`;

  return `${price} ${currency}`;
};
